import AISignals from '../../../../resources/Model/AISignals';
import BemClass from '@upsales/components/Utils/bemClass';
import { Flex, Text, Tooltip } from '@upsales/components';
import { renderToString } from 'react-dom/server';
import React from 'react';
import { useTranslation } from 'Components/Helpers/translate';

import './MailAISidebar.scss';

type MailAISidebarProps = {
	signals: AISignals;
	className?: string;
};

const MailAISidebar = ({ signals, className }: MailAISidebarProps) => {
	const classes = new BemClass('MailAISidebar').add(className);
	const { t } = useTranslation();

	const renderFlags = (text: string, flags: string[], style: string, indicator: string) => (
		<Flex direction="column" gap="u2">
			<Flex alignItems="center" gap="u2">
				<Flex
					className={classes.elem('signalAnalysisContainer').mod(style).b()}
					alignItems="center"
					justifyContent="center"
				>
					<div>{indicator}</div>
				</Flex>
				<Text bold>{text}</Text>
			</Flex>
			{flags.map((item, index) => (
				<Text key={index} color="grey-11">
					{item}
				</Text>
			))}
		</Flex>
	);

	const renderRecommendations = (text: string, recommendations: string[]) => (
		<Flex direction="column" gap="u2">
			<Flex alignItems="center" gap="u2">
				<Flex
					className={classes.elem('signalAnalysisContainer').mod('recommendations').b()}
					alignItems="center"
					justifyContent="center"
				>
					<div>{'!'}</div>
				</Flex>
				<Text bold>{text}</Text>
			</Flex>
			<Flex direction="column" gap="u2">
				{recommendations.map((item, index) => (
					<Flex key={index} alignItems="flex-start" gap="u2">
						<Text color="grey-11">{item}</Text>
					</Flex>
				))}
			</Flex>
		</Flex>
	);

	return (
		<Flex className={classes.b()} direction="column" space="ptl prl pbl pll" gap="u5">
			<Text bold className={classes.elem('summary').b()}>
				{signals.summary}
			</Text>
			{signals.redFlags?.length ? renderFlags(t('default.negative'), signals.redFlags, 'negative', '-') : null}
			{signals.greenFlags?.length
				? renderFlags(t('default.positive'), signals.greenFlags, 'positive', '+')
				: null}
		{signals.recommendations?.length && (signals.greenFlags?.length || signals.redFlags?.length)
			? renderRecommendations(t('default.recommendations'), signals.recommendations)
			: null}
		</Flex>
	);
};

export const TooltippedMailAISidebar = ({
	signals,
	children,
	interactive
}: {
	signals?: AISignals;
	children: JSX.Element | string;
	interactive?: 'true' | undefined;
}) => {
	const hasTooltip = signals && (signals.summary?.length ?? 0) > 10;
	return hasTooltip ? (
		<Tooltip
			theme="white"
			position="bottom"
			interactive={interactive}
			delay={1000}
			title={renderToString(
				<Flex gap="u2">
					<MailAISidebar signals={signals} className="Tooltipped" />
				</Flex>
			)}
		>
			{children}
		</Tooltip>
	) : (
		<>{children}</>
	);
};

export default MailAISidebar;
